// Define our labelmap
const labelMap = {
    1:{name:'A',                color:'AliceBlue'},
    2:{name:'B',                color:'AntiqueWhite'},
    3:{name:'C',                color:'Aqua'},
    4:{name:'D',                color:'Aquamarine'},
    5:{name:'E',                color:'Azure'},
    6:{name:'F',                color:'Beige'},
    7:{name:'G',                color:'Bisque'},
    8:{name:'H',                color:'Black'},
    9:{name:'I',                color:'BlanchedAlmond'},
    10:{name:'J',               color:'Blue'},
    11:{name:'K',               color:'BlueViolet'},
    12:{name:'L',               color:'Brown'},
    13:{name:'M',               color:'BurlyWood'},
    14:{name:'N',               color:'CadetBlue'},
    15:{name:'O',               color:'Chartreuse'},
    16:{name:'P',               color:'Chocolate'},
    17:{name:'Q',               color:'Coral'},
    18:{name:'R',               color:'CornflowerBlue'},
    19:{name:'S',               color:'Red'},
    20:{name:'T',               color:'Crimson'},
    21:{name:'U',               color:'Cyan'},
    22:{name:'V',               color:'purple'},
    23:{name:'W',               color:'DarkCyan'},
    24:{name:'X',               color:'DarkGoldenRod'},
    25:{name:'Y',               color:'DarkGray'},
    26:{name:'Z',               color:'DarkGrey'},
    27:{name:'1',               color:'DarkGreen'},
    28:{name:'3',               color:'DarkKhaki'},
    29:{name:'4',               color:'DarkMagenta'},
    30:{name:'5',               color:'DarkOliveGreen'},
    31:{name:'6',               color:'DarkOrange'},
    32:{name:'7',               color:'DarkOrchid'},
    33:{name:'8',               color:'DarkRed'},
    34:{name:'9',               color:'DarkSalmon'},
    35:{name:'YES',             color:'DarkSeaGreen'},
    36:{name:'NO',              color:'DarkSlateBlue'},
    37:{name:'HELLO',           color:'DarkTurquoise'},
    38:{name:'ILOVEYOU',        color:'ForestGreen'},
    39:{name:'2',               color:'Indigo'},
}

// Define a drawing function
export const drawRect = (boxes, classes, scores, threshold, imgWidth, imgHeight, ctx)=>{
    for(let i=0; i<=boxes.length; i++){
        if(boxes[i] && classes[i] && scores[i]>threshold){
            // Extract variables
            const [y,x,height,width] = boxes[i]
            const text = classes[i]
            
            // Set styling
            ctx.strokeStyle = labelMap[text]['color']
            ctx.lineWidth = 8
            ctx.fillStyle = 'red'
            ctx.font = '30px Arial' 
			
			var confidence = "Unknown";
			var confScore = Math.round(scores[i]*100)/100;
			
			if(confScore >= 0.75){
				confidence= "High";
			} else if (confScore > 0.35) {
				confidence = "Medium";
			} else {
				confidence = "Low";
			}
			
            // DRAW
            ctx.beginPath()
            ctx.fillText(labelMap[text]['name'] + ' - Confidence: ' + confidence, x*imgWidth, y*imgHeight-15)
            ctx.rect(x*imgWidth, y*imgHeight, width*imgWidth/1.8, height*imgHeight/1.6);
            ctx.stroke()

        }
    }
}
